import "./Section2About.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEarthAmericas } from "@fortawesome/free-solid-svg-icons";
export default function Section2About() {
  return (
    <>
      <div className="main-section2-about col-12">
        <div className="container container-section2-about">
          <div className="column-section2-about column1">
            <div className="top-column1-about item-column1 s-item-color">
              <i className="bi bi-feather icon-item-column s-color"></i>
              <h1 className="title-item-column s-color">رسالتنا</h1>
              <p className="desc-item-column s-color">
                نحن على ثقة ان الخدمات المميزة التي نخصصها لرحلتك العقارية هي
                السبب الأساسي لرضاك ونجاحنا
              </p>
            </div>
            <div className="bottom-column1-about item-column1">
              <FontAwesomeIcon
                icon={faEarthAmericas}
                className="icon-item-column"
              />
              <h1 className="title-item-column">هدفنا</h1>
              <p className="desc-item-column">
                نقدم لك الدعم والإرشاد في كل خطوة، سواء كنت مبتدئًا في الشراء،
                أو مستثمرًا محترفًا، أو بائعًا لعقارك
              </p>
            </div>
          </div>

          <div className="column-section2-about column2">
            <div className="top-column2-about item-column1">
              <i className="bi bi-fingerprint icon-item-column"></i>
              <h1 className="title-item-column">رؤيتنا</h1>
              <p className="desc-item-column">
                العثور على البيت المثالي ليس مجرد بيع وشراء، بل هو بناء ذكريات،
                وتكوين العائلات، وتحقيق الأحلام. لديك أبعاد بيتك المثالي؟ راسلنا
                الآن
              </p>
            </div>
            <img
              src={require("../../assats/carousal1.png")}
              alt=""
              className="bottom-column2-about"
            />
          </div>

          <div className="column-section2-about column3 column-section2-about-tab">
            <img
              src={require("../../assats/pro.jpg")}
              alt=""
              className="top-column3-about"
            />
            <div className="bottom-column3-about item-column1 ">
              <i className="bi bi-fingerprint icon-item-column "></i>
              <h1 className="title-item-column">قيمنا الفريدة</h1>
              <p className="desc-item-column">
                قيمنا الفريدة تتجسد في التعاون، وتعزيز ثقافة العمل التطوعي،
                وتحقيق الأهداف الإجتماعية، والعطاء والمشاركة، والالتزام
                بالمسؤولية، والشفافية، والاحترام
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
